import {makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IModalsStore} from "data/stores/modals/modals.store";
import {IMAGES_URL} from "data/constants";
import {copyToClipboard} from "data/utils/copyToClipboard";
import {ModalType} from "data/enums";
import {ICoupon} from "data/providers/api/coupon.api.provider";
import {NullOrEmpty} from "data/types/generics";

export interface ICouponModalController extends ViewController {
	get isOpen(): boolean;
	get coupon(): NullOrEmpty<ICoupon>;
	get code(): string;
	get couponUrl(): string;
	get isShowDisclaimer(): boolean;

	close: () => void;
	copyCode: () => void;
	toggleDisclaimer: () => void;
}

@injectable()
export class CouponModalController implements ICouponModalController {
	@observable private _isShowDisclaimer = false;

	get isOpen() {
		if (this._isShowDisclaimer) {
			return false;
		}

		return this._modalsStore.modal === ModalType.COUPON;
	}

	get coupon() {
		return this._modalsStore.modalContent as NullOrEmpty<ICoupon>;
	}

	get code() {
		return this.coupon?.code || "";
	}

	get couponUrl() {
		const imageUrl = this.coupon?.imageUrl || "";
		return `${IMAGES_URL}${imageUrl}.png`;
	}

	get isShowDisclaimer() {
		return this._isShowDisclaimer;
	}

	constructor(@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore) {
		makeAutoObservable(this);
	}

	close = () => {
		this._modalsStore.hideModal();
	};

	copyCode = async () => {
		await copyToClipboard(this.code);
	};

	toggleDisclaimer = () => {
		this._isShowDisclaimer = !this._isShowDisclaimer;
	};

	init() {
		return;
	}

	dispose() {
		return;
	}
}
